<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="visible"
  >
    <div class="flex items-center justify-between px-6 mt-6">
      <h5>
        {{ Object.entries(this.data).length === 0 ? 'ADD NEW' : 'UPDATE' }}
        PAYMENT CHANNEL
      </h5>
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('closeSidebar')"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- User Info -->
        <vx-card class="mt-base" title="Payment Channel" no-shadow card-border>
          <div class="pl-3 pr-3 vx-row">
            <!-- Type -->
            <div class="w-full mt-5">
              <label class="text-sm"
                ><span class="text-error">*</span> Payment Channel</label
              >
              <v-select
                :options="types"
                label="text"
                name="type"
                @input="onChangeType()"
                :reduce="type => type.value"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="type"
                class="w-full"
                v-validate="'required'"
              />
              <span class="text-sm text-danger" v-show="errors.has('type')">{{
                errors.first('type')
              }}</span>
            </div>

            <!-- Provider -->
            <div class="w-full mt-5">
              <label class="text-sm"
                ><span class="text-error">*</span> Provider</label
              >
              <v-select
                :disabled="this.type === null || this.type === 'upload receipt'"
                @change="onChangeProvider"
                :options="selectedTypeProviders"
                label="text"
                name="type"
                :reduce="type => type.value"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="provider"
                class="w-full"
                v-validate="type !== 'upload receipt' ? 'required' : ''"
              />
              <span
                class="text-sm text-danger"
                v-show="errors.has('provider')"
                >{{ errors.first('provider') }}</span
              >
            </div>
          </div>
        </vx-card>

        <!-- Customer Group -->
        <vx-card
          class="mt-base"
          title="Set Customer Access"
          no-shadow
          card-border
        >
          <div class="pl-3 pr-3 vx-row">
            <div class="w-full mt-5">
              <label class="text-sm"
                ><span class="text-error"></span> Customer Group</label
              >
              <v-select
                :options="customerGroups"
                label="groupName"
                name="groupName"
                @change="onCustomerGroupChange"
                :reduce="customerGroups => customerGroups.groupId"
                :clearable="true"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="customerGroupId"
                class="w-full"
              />
              <span
                class="text-sm text-danger"
                v-show="errors.has('customerGroup')"
                >{{ errors.first('customerGroup') }}</span
              >
            </div>
          </div>
          <div class="mt-5">
            <p>
              <i
                >Leave empty if all customer could pay with this payment
                channel.</i
              >
            </p>
          </div>
        </vx-card>

        <div v-if="provider">
          <bill-plz-form
            v-if="provider === paymentProviders.BillPlz"
            @change="verifyKey"
            :data="form"
          />
          <smart-fund-form
            v-if="provider === paymentProviders.SmartFund"
            @change="verifyKey"
            :data="form"
          />
          <e-ghl-form
            v-if="provider === paymentProviders.EGhl"
            @change="verifyKey"
            :data="form"
          />
          <ozopay-form
            v-if="provider === paymentProviders.Ozopay"
            @change="verifyKey"
            :data="form"
          />
          <cimb-form
            v-if="provider === paymentProviders.Cimb"
            @change="verifyKey"
            :data="form"
          />
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button
        :disabled="isProcessing || !this.isValidate"
        class="mr-3"
        @click="submitData"
      >
        <div v-if="isProcessing === false">Submit</div>
        <div v-if="isProcessing">Submitting...</div>
      </vs-button>
      <vs-button type="border" color="dark" @click="$emit('closeSidebar')"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import GenericUpload from '@/views/components/override/GenericUpload.vue'
import vSelect from 'vue-select'
import BillPlzForm from './forms/BillPlzForm'
import SmartFundForm from './forms/SmartFundForm'
import EGhlForm from './forms/EGhlForm'
import OzopayForm from '@/views/apps/setting/forms/OzopayForm'
import CimbForm from './forms/CimbForm.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      isUpdate: false,
    },
    data: {
      type: Object,
      default: () => {},
      isUpdate: false,
    },
  },
  components: {
    OzopayForm,
    VuePerfectScrollbar,
    GenericUpload,
    vSelect,
    BillPlzForm,
    SmartFundForm,
    EGhlForm,
    CimbForm,
  },
  watch: {
    type: function(val) {
      if (val === null) return null
      this.provider = null
      this.selectedTypeProviders = this.providers.filter(function(arr) {
        return arr.type === val
      })
    },
  },
  data() {
    return {
      isUpdate: false,
      isValidate: false,
      isProcessing: false,
      paymentProviders: {
        BillPlz: 'billplz',
        SmartFund: 'smart fund',
        EGhl: 'e-ghl',
        Ozopay: 'ozopay',
        Cimb: 'cimb',
      },
      providers: [
        { text: 'Billplz', value: 'billplz', type: 'fpx' },
        { text: 'E-GHL', value: 'e-ghl', type: 'credit card' },
        { text: 'Smart Fund', value: 'smart fund', type: 'smart fund' },
        { text: 'Ozopay', value: 'ozopay', type: 'fpx' },
        { text: 'Ozopay', value: 'ozopay', type: 'fpxb2b' },
        { text: 'CIMB', value: 'cimb', type: 'fpx' },
      ],
      provider: null,
      customerGroupId: null,
      customerGroups: [],
      selectedCustomerGroup: [],
      type: null,
      form: {
        accountId: null,
        key: null,
      },
      selectedTypeProviders: [],
      types: [
        {
          text: 'Credit Card',
          value: 'credit card',
        },
        {
          text: 'FPX',
          value: 'fpx',
        },
        {
          text: 'FPX B2B',
          value: 'fpxb2b',
        },
        {
          text: 'Smart Fund',
          value: 'smart fund',
        },
        {
          text: 'Upload Receipt',
          value: 'upload receipt',
        },
      ],
      settings: {
        // perfect scrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
  },
  created() {
    this.isUpdate = Object.entries(this.data).length > 0
    this.fetchCustomerGroups()
    if (this.isUpdate) {
      this.isValidate = true
      this.fetchRecord()
    } else {
      this.form = {}
    }
  },
  methods: {
    async fetchCustomerGroups() {
      let response = await this.$store
        .dispatch('customerGroups/fetchRecords')
        .catch(err => {
          console.error(err)
        })

      response.data.forEach(cg => {
        this.customerGroups.push({
          groupId: cg.groupId,
          groupName: cg.groupName,
        })
      })
      // this.customerGroups = response.data;
    },
    async fetchRecord() {
      let response = await this.$store
        .dispatch('paymentChannels/fetchRecord', this.data.type)
        .catch(err => {
          console.error(err)
        })
      this.form = response.data
      this.type = response.data.type
      this.provider = response.data.provider
      this.form.provider = response.data.provider
      this.customerGroupId = response.data.customerGroupId
    },
    async submitData() {
      await this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        const obj = {
          provider: this.provider,
          type: this.type,
          accountId: this.form.accountId,
          key: this.form.key,
          customerGroupId: this.customerGroupId,
        }

        let action = this.isUpdate
          ? 'paymentChannels/updateRecord'
          : 'paymentChannels/addRecord'
        let successMessage = this.isUpdate
          ? 'Updated Successful'
          : 'Added Successful'
        let successText = this.isUpdate
          ? 'Information has successfully updated'
          : 'Record has successfully Added'
        let failMessage = this.isUpdate ? 'Fail to Update' : 'Failed to Add'

        this.isProcessing = true
        this.$store
          .dispatch(action, obj)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: successMessage,
              text: successText,
            })
            this.$emit('closeSidebar')
          })
          .catch(err => {
            let message = 'fail'
            if (err.response.errors && err.response.errors.length > 0) {
              message = err.response.errors[0]
            } else {
              message = err.response.message
            }
            this.$vs.notify({
              color: 'danger',
              title: failMessage,
              text: message,
            })
          })
          .finally(() => {
            this.isProcessing = false
          })
      })
    },
    async verifyKey(form) {
      this.form = form
      await this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        const obj = {
          provider: this.provider,
          accountId: form.accountId,
          key: form.key,
        }

        this.$store
          .dispatch('paymentChannels/verifyGateway', obj)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Payment Gateway Key is validated',
            })
            this.isValidate = true
          })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {
            this.$vs.notify({
              color: 'danger',
              title: 'Verification Failed',
              text: 'Payment Gateway Key is invalid',
            })
            this.isValidate = false
          })
      })
    },
    showUpdateSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'Success',
        text: 'Information has been updated successfully',
      })
    },
    onChangeType() {
      console.log('onchange: ' + this.type)
      if (this.type === 'upload receipt') this.isValidate = true
    },
    onChangeProvider() {
      this.provider = this.data.provider
    },
    onCustomerGroupChange() {},
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.text-error {
  color: #e85600;
}
</style>
